import ADPRefcodeService from "../../../services/admin/ADPRefcodeService";
import ASTLogqrService from "../../../services/ast/ASTLogqrService";


class LogQrService {

    async getClientState(): Promise<any> {
        const clientState = localStorage.getItem('clientState');
        return clientState ? JSON.parse(clientState) : null
    }

    async setSearchParam(recordFilter: any, pathName: any): Promise<any> {
        let param = { recordFilter };
        localStorage.setItem(pathName, JSON.stringify(param));
    }

    async getSearchParam(pathName: any): Promise<any> {
        const searchParam = localStorage.getItem(pathName);
        return searchParam ? JSON.parse(searchParam) : null
    }

    async findAllLog(recordFilter: any): Promise<any> {
        return await ASTLogqrService.findAll(recordFilter);
    }


    async getDropdown(moduleId: string, referenceGroup: string): Promise<any> {
        return await ADPRefcodeService.getDropdownByModuleIdAndReferencegroup(moduleId, referenceGroup);
    }


    async createInstrument(item: any): Promise<any> {
        return await ASTLogqrService.create(item);
    }

    async updateInstrument(item: any): Promise<any> {
        return await ASTLogqrService.update(item.instrumentId, item);
    }

   

   
}

export default new LogQrService();
